import React, {useState, useEffect} from 'react';
import Config from "./core/config";
import sgeImg from "./img/sge-sistemas-logo.png";
import {isUserAdmin} from "./utils/requestUtils";
import {clearAuthSession, setAuthSession} from "./utils/auth";

const apiUrl = Config.apiUrl;

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loginError, setLoginError] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const reason = params.get('reason');
        const stored = sessionStorage.getItem('loginMessage');
        if (stored) {
            setLoginError(stored);
            sessionStorage.removeItem('loginMessage');
        } else if (reason === 'OUTSIDE_WORK_HOURS') {
            setLoginError('Acesso permitido apenas no horário de trabalho definido para sua empresa.');
        } else if (reason === 'AUTH_TOKEN_EXPIRED') {
            setLoginError('Sessão expirada. Faça login novamente.');
        }
        // Garante que qualquer sessão antiga não fique pendurada na tela de login.
        clearAuthSession();
    }, []);

    const handleLogin = async () => {
        try {
            if (!email) {
                setLoginError('Informe o e-mail.');
                return;
            }
            if (!password) {
                setLoginError('Informe a senha.');
                return;
            }

            const basicAuthToken = btoa(`${email}:${password}`);

            const response = await fetch(`${apiUrl}/api/users/login`, {
                method: 'GET',
                headers: {
                    'Authorization': `Basic ${basicAuthToken}`
                },
            });

            if (response.ok) {
                const payload = await response.json();
                const token = payload.token;
                const userData = payload.user;
                const expiresInMillis = payload.expiresInMillis;

                if (!token || !userData) {
                    setLoginError('Resposta de login inválida.');
                    return;
                }

                setAuthSession(token, userData, expiresInMillis);

                try {
                    const userAdmin = await isUserAdmin();

                    const rawRedirect = sessionStorage.getItem('redirectAfterLogin');
                    sessionStorage.removeItem('redirectAfterLogin');

                    // Só aceita paths internos (começando com /, exceto //) e que não voltem para /login.
                    const isInternalPath = !!rawRedirect
                        && rawRedirect.startsWith('/')
                        && !rawRedirect.startsWith('//');
                    const pointsToLogin = !!rawRedirect
                        && (rawRedirect === '/login' || rawRedirect.startsWith('/login?') || rawRedirect.startsWith('/login/'));
                    const safeRedirect = isInternalPath && !pointsToLogin ? rawRedirect : null;
                    const redirectIsAdmin = safeRedirect != null && safeRedirect.startsWith('/admin');

                    // Usa o redirect guardado quando ele bate com o papel do usuário; caso contrário,
                    // manda o admin para /admin e o usuário comum para /app.
                    let target;
                    if (userAdmin) {
                        target = redirectIsAdmin ? safeRedirect : '/admin';
                    } else {
                        target = safeRedirect && !redirectIsAdmin ? safeRedirect : '/app';
                    }

                    setLoginError(null);
                    window.location.assign(target);
                } catch (error) {
                    setLoginError('Erro fazer login.');
                }
            } else if (response.status === 403) {
                try {
                    const data = await response.json();
                    setLoginError(data.message || 'Acesso permitido apenas no horário de trabalho definido para sua empresa.');
                } catch (e) {
                    setLoginError('Acesso permitido apenas no horário de trabalho definido para sua empresa.');
                }
            } else {
                setLoginError('E-mail ou senha inválidos');
            }
        } catch (error) {
            console.error('Erro ao fazer login:', error);
            setLoginError('Erro ao fazer login. Tente novamente mais tarde.');
        }
    };

    return (
        <div style={{
            width: '100%',
            minHeight: '100vh',
            background: 'var(--gradient-login-background)',
            backgroundAttachment: 'fixed'
        }}>
            <div style={{paddingTop: '15vh'}}>
                <div style={{
                    margin: 'auto',
                    width: '220px',
                    padding: '20px',
                    border: '1px solid rgba(92, 82, 89, 0.15)',
                    boxShadow: '0 10px 32px rgba(92, 82, 89, 0.12)',
                    borderRadius: '10px',
                    backgroundColor: '#ffffff'
                }}>

                    <form>

                        <div style={{marginTop: '5px', alignItems: 'center', width: '200px'}}>
                            <div style={{textAlign: 'center'}}>
                                <img src={sgeImg} alt="Logo" style={{width: '190px'}}/></div>
                            <h2>Login</h2>
                            <div style={{width: '180px'}}>E-mail:</div>
                            <input
                                style={{width: '210px', textTransform: 'none'}}
                                type="text"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleLogin(); } }}
                            />
                        </div>

                        <div style={{marginTop: '5px', alignItems: 'center', width: '200px'}}>
                            <div style={{width: '180px'}}>Senha:</div>
                            <input
                                style={{width: '210px', textTransform: 'none'}}
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); handleLogin(); } }}
                            />
                        </div>
                        <div style={{marginTop: '5px', alignItems: 'center', width: '200px'}}>
                            <button style={{width: '210px'}} type="button" onClick={handleLogin}>
                                Login
                            </button>
                        </div>
                    </form>
                    {loginError && <p style={{color: 'var(--semantic-error-text)'}}>{loginError}</p>}
                </div>
            </div>
        </div>
    );
};

export default Login;
